import { Toaster } from "react-hot-toast";

// react-hot-toast の表示設定（テーマに合わせる）。
function ToastContainer() {
  return (
    <Toaster
      position="top-right"
      containerStyle={{ top: "4.75rem" }}
      toastOptions={{
        duration: 3500,
        style: {
          fontSize: "0.9rem",
          color: "#222c3a",
          boxShadow: "0 4px 16px rgba(44, 62, 80, 0.22)",
          maxWidth: "min(92vw, 460px)",
        },
        success: {
          duration: 3000,
          iconTheme: { primary: "#34c759", secondary: "#fff" },
        },
        error: {
          duration: 4500,
          iconTheme: { primary: "#e5484d", secondary: "#fff" },
        },
      }}
    />
  );
}

export default ToastContainer;
